/* tslint:disable */
/* eslint-disable */

/**
 * Type of transport
 */
export enum TransportType {
  Flight = 'FLIGHT',
  Bus = 'BUS',
  Train = 'TRAIN',
  Unknown = 'UNKNOWN'
}
